import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Checkbox,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import CommonBackDrop from "../../../common/components/CommonBackDrop/CommonBackDrop";
import CommonDynamicTableNew from "../../../common/components/CommonTable/CommonDynamicTableNew";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import DatePickerField from "../../../common/components/FormFields/DatePickerFieldNew";
import DropdownField from "../../../common/components/FormFields/DropdownField";
import RadioField from "../../../common/components/FormFields/RadioField";
import {
  errorAlert,
  successAlert,
  warningAlert,
} from "../../../common/components/Toasts/CustomToasts";
import {
  fetchAlterDoctorDetailsByBillNo,
  saveAlterDoctorByBillNo,
} from "../../services/alterDoctorServices/AlterDoctorServices";
import { getDoctorList } from "../../../billing/services/BillingServices";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import { fetchDoctor } from "../../../commonServices/miscellaneousServices/MiscServices";

const type = [
  {
    id: 0,
    value: 0,
    label: "OPD",
  },
  {
    id: 1,
    value: 1,
    label: "IPD",
  },
];
const AlterDoctor = () => {
  const [alterDoctorDetailedInfo, setAlterDoctorDetailedInfo] = useState([]);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [openPost, setOpenPost] = useState(false);
  const [doctorOptions, setDoctorOptions] = useState([]);
  const [checkedValue, setCheckedValue] = useState(false);

  const { control, watch, setValue, register, reset } = useForm({
    defaultValues: {
      billNo: "",
      type: 0,
      fromDate: new Date(),
      toDate: new Date(),
    },
  });

  let getBillNo = watch("billNo");
  let getType = watch("type");
  let getFromDate = watch("fromDate");
  let getToDate = watch("toDate");

  const handleDoctorChange = (searchString) => {
    if (searchString !== "") {
      fetchDoctor(searchString).then((response) => {
        setDoctorOptions(response.data.result);
      });
    }
  };

  const renderInput = (row, index, header) => {
    setValue(
      `doctorName${index}`,
      row?.DoctorName !== null
        ? {
            id: row?.DoctorId,
            value: row?.DoctorId,
            label: row?.DoctorName,
          }
        : null
    );
    return (
      <div className="my-2">
        {header === "Doctor Name" && (
          <div className="w-80 py-5">
            <SearchDropdown
              control={control}
              name={`doctorName${index}`}
              label="Doctor Name"
              //   className="border-black rounded px-1"
              dataArray={doctorOptions}
              searchIcon={true}
              isSearchable={true}
              isClearable={true}
              handleInputChange={handleDoctorChange}
              inputRef={{
                ...register(`doctorName${index}`, {
                  onChange: (e) => {
                    let temp = [...alterDoctorDetailedInfo];
                    temp[index].DoctorId =
                      e.target.value !== null ? e.target.value?.id : null;
                    temp[index].DoctorName =
                      e.target.value !== null ? e.target.value?.label : null;
                    setAlterDoctorDetailedInfo(temp);
                  },
                }),
              }}
            />
          </div>
        )}
      </div>
    );
  };

  const alterDoctorDetailsByBillNo = () => {
    setOpenBackdrop(true);
    fetchAlterDoctorDetailsByBillNo({
      type: getType,
      billNo: getBillNo,
      fromDate: format(getFromDate, "yyyy-MM-dd"),
      toDate: format(getToDate, "yyyy-MM-dd"),
    })
      .then((response) => {
        setOpenBackdrop(false);
        console.log("response321", response.data.result);
        setAlterDoctorDetailedInfo(
          response?.data?.result?.map((val) => ({
            ...val,
            Checked: false,
          }))
        );
      })
      .catch((error) => {
        console.log("error", error);
        errorAlert(error.message);
        setOpenBackdrop(false);
      });
  };

  const saveAlterDoctorInfo = () => {
    setOpenBackdrop(true);
    saveAlterDoctorByBillNo(
      alterDoctorDetailedInfo
        ?.filter((obj) => obj?.Checked === true)
        ?.map((val) => ({
          doctorId: val?.DoctorId,
          chargeId: val?.ChargeId,
        }))
    )
      .then((response) => {
        setOpenBackdrop(false);
        successAlert(response.data.message);
        setOpenPost(false);
        alterDoctorDetailsByBillNo();
        setCheckedValue(false);
      })
      .catch((error) => {
        setOpenBackdrop(false);
        errorAlert(error.message);
        setOpenPost(false);
      });
  };

  console.log("alterDoctorDetailedInfo321", alterDoctorDetailedInfo);

  useEffect(() => {
    getDoctorList().then((response) => {
      setDoctorOptions(response?.data?.result);
    });
  }, []);

  return (
    <div className="mt-12 mb-2 space-y-2">
      <div className="text-center text-black font-bold text-xl">
        Alter Doctor
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-6 xl:grid-cols-8 2xl:grid-cols-10 gap-3">
        <fieldset className="flex gap-1 justify-center items-center bg-white border rounded px-2 -mt-2 lg:col-span-2">
          <legend className="font-semibold text-xs px-2">Bill Type</legend>
          <div className="-my-2 whitespace-nowrap">
            <RadioField control={control} name="type" dataArray={type} />
          </div>
        </fieldset>
        <div className="">
          <TextField
            control={control}
            name="billNo"
            size="small"
            {...register("billNo")}
            label="Bill No"
            inputProps={{
              style: {
                textTransform: "capitalize",
                fontSize: "14px",
                height: "18px",
              },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div className="flex space-x-2 lg:col-span-2">
          <DatePickerField
            control={control}
            name="fromDate"
            label="From Date"
            inputFormat="dd-MM-yyyy"
          />
          <DatePickerField
            control={control}
            name="toDate"
            label="To Date"
            inputFormat="dd-MM-yyyy"
          />
        </div>
        <CommonButton
          type="button"
          searchIcon={true}
          className="bg-customBlue text-white"
          onClick={() => {
            if (getBillNo !== "") {
              alterDoctorDetailsByBillNo();
            } else {
              warningAlert("Enter bill no...!");
            }
          }}
        />
      </div>
      <div className="bg-[#F1F1F1] border rounded grid grid-cols-4 lg:grid-cols-5 xl:grid-cols-7 lg:justify-between px-2 py-1 text-[15px]">
        <div className="flex items-center text-customBlue font-semibold col-span-2">
          <label className="">Patient Name</label>
          <label>&nbsp;:&nbsp;{alterDoctorDetailedInfo[0]?.PatientName}</label>
        </div>
        <div className="flex items-center">
          <label className="font-semibold">MR No</label>
          <label>&nbsp;:&nbsp;{alterDoctorDetailedInfo[0]?.MRNo}</label>
        </div>
        <div className="flex items-center">
          <label className="font-semibold">Bill Date</label>
          <label>&nbsp;:&nbsp;{alterDoctorDetailedInfo[0]?.BillDate}</label>
        </div>
      </div>
      <div>
        {alterDoctorDetailedInfo?.length > 0 ? (
          <Box sx={{ width: "100%", overflow: "hidden" }}>
            <Paper sx={{ width: "100%", my: 1 }}>
              <TableContainer
                sx={{
                  "&::-webkit-scrollbar": {
                    width: 7,
                    height: 10,
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "#ebebeb",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#7393b3",
                    borderRadius: 4,
                    cursor: "pointer",
                  },
                }}
              >
                <Table
                  size="small"
                  stickyHeader
                  aria-label="sticky table"
                  sx={{
                    border: 1,
                    borderColor: "#e0e0e0",
                    paddingY: "scroll",
                    outline: "none",
                  }}
                  tabIndex="0"
                  className="MuiTableContainer-root"
                >
                  <TableHead>
                    <TableRow
                      sx={{
                        "& th": {
                          paddingY: 0.5,
                          backgroundColor: "#F1F1F1",
                        },
                      }}
                    >
                      <TableCell>
                        <div className="flex items-center">
                          <Checkbox
                            checked={checkedValue}
                            size="small"
                            // name="selectAll"
                            // control={control}
                            // {...register("selectAll")}
                            onChange={(e) => {
                              const isChecked = e.target.checked;
                              console.log("eeeee", isChecked);
                              setCheckedValue(isChecked);
                              const updated = alterDoctorDetailedInfo.map(
                                (val) => ({
                                  ...val,
                                  Checked: isChecked,
                                })
                              );
                              setAlterDoctorDetailedInfo(updated);
                            }}
                          />
                          <label>Select All</label>
                        </div>
                      </TableCell>
                      <TableCell>Service Code</TableCell>
                      <TableCell>Service Name</TableCell>
                      <TableCell>Doctor Name</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {alterDoctorDetailedInfo?.map((row, index) => {
                      setValue(
                        `doctorName${index}`,
                        row?.DoctorId !== null
                          ? {
                              id: row?.DoctorId,
                              value: row?.DoctorId,
                              label: row?.DoctorName,
                            }
                          : null
                      );
                      return (
                        <TableRow>
                          <TableCell>
                            <Checkbox
                              size="small"
                              checked={row?.Checked}
                              onChange={(e) => {
                                let temp = [...alterDoctorDetailedInfo];
                                temp[index].Checked = e?.target?.checked;
                                setAlterDoctorDetailedInfo(temp);
                                if (e?.target?.checked === false) {
                                  setCheckedValue(false);
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell>{row?.ServiceCode}</TableCell>
                          <TableCell>{row?.ServiceName}</TableCell>
                          <TableCell>
                            {
                              <div className="w-96 my-2">
                                <SearchDropdown
                                  control={control}
                                  name={`doctorName${index}`}
                                  isClearable={true}
                                  searchIcon={true}
                                  dataArray={doctorOptions}
                                  handleInputChange={handleDoctorChange}
                                  placeholder="Doctor Name"
                                  inputRef={{
                                    ...register(`doctorName${index}`, {
                                      onChange: (e) => {
                                        let temp = [...alterDoctorDetailedInfo];
                                        temp[index].DoctorId =
                                          e?.target?.value !== null
                                            ? e?.target?.value?.id
                                            : null;
                                        temp[index].DoctorName =
                                          e?.target?.value !== null
                                            ? e?.target?.value?.label
                                            : null;
                                        setAlterDoctorDetailedInfo(temp);
                                      },
                                    }),
                                  }}
                                />
                              </div>
                            }
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Box>
        ) : (
          <div className="h-60 border rounded flex items-center justify-center font-semibold">
            No Payments Found...
          </div>
        )}
      </div>
      <div className="flex space-x-2 justify-end">
        <CommonButton
          type="button"
          label="Reset"
          className="border border-customRed text-customRed"
          onClick={() => {
            reset();
            setAlterDoctorDetailedInfo([]);
          }}
        />
        <CommonButton
          type="button"
          label="Alter Doctor"
          className="bg-customGreen text-white"
          disabled={alterDoctorDetailedInfo?.length === 0}
          onClick={() => {
            if (alterDoctorDetailedInfo?.some((val) => val.Checked === true)) {
              setOpenPost(true);
            } else {
              warningAlert("Select record to alter doctor...!");
            }
          }}
        />
      </div>
      <ConfirmationModal
        confirmationOpen={openPost}
        confirmationHandleClose={() => setOpenPost(false)}
        confirmationSubmitFunc={saveAlterDoctorInfo}
        confirmationLabel="Confirmation"
        confirmationMsg="Are you sure want to alter doctor changes...!"
        confirmationButtonMsg="Confirm"
      />
      <CommonBackDrop openBackdrop={openBackdrop} />
    </div>
  );
};

export default AlterDoctor;
